export const HEART_SAVED_NOTIFICATION = 'SAVED';
export const HEART_REMOVED_NOTIFICATION = 'REMOVED';
export const HEART_ERROR_NOTIFICATION = 'ERROR';
